<template>
    <v-layout row justify-center>
        <v-dialog v-model="loginModal" persistent max-width="590">
            <template v-slot:activator="{ on }">
                <!--<v-btn color="black" dark v-on="on">Open Dialog</v-btn>-->
            </template>
            <v-card class="elevation-12">
                <v-toolbar color="black"
                           dark
                           flat
                           class="kill-margin">

                    <!--<v-toolbar-title class="text-white">{{$t('security.login_descr')}}</v-toolbar-title>-->
                    {{$t('security.login_descr')}}
                </v-toolbar>
                <ProgressBar :loading="loading" color="deep-purple accent-4" />
                <v-list three-line subheader>
                    <!--<v-subheader>{{$t('security.login_title')}}</v-subheader>-->
                </v-list>
                <v-divider></v-divider>

                <v-card-text>
                    <v-form class="pa-4" ref="form" :autocomplete="autocomplete">
                        <v-flex xs12 sm12>
                            <!--v-text-field-->
                            <v-text-field id="usernameId" v-model="username"
                                          :type="'text'"
                                          :label="$t('security.username')"
                                          :rules="rules"
                                          :browser-autocomplete="autocomplete"
                                          autofocus="autofocus"
                                          counter></v-text-field>

                        </v-flex>

                        <v-flex xs12 sm12>
                            <v-expand-transition>
                                <v-text-field v-model="password"
                                              :label="$t('security.password')"
                                              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                              :type="show1 ? 'text' : 'password'"
                                              :rules="rules"
                                              counter
                                              @click:append="show1 = !show1"
                                              v-if="!passwordForgottenMode"></v-text-field>
                            </v-expand-transition>

                        </v-flex>
                        <div class="text-left">
                            <p class="red--text" v-if="passwordForgottenMode">{{ $t('security_login_dialog.instructions_reset_pass') }}</p>

                            <v-list dense @click="" v-if="passwordForgottenMode">
                                <small>{{ $t('security_login_dialog.password_forgoten_1') }}</small>
                                <small><a :href="mailto"> {{ $t('security_login_dialog.password_forgoten_2') }} </a></small>
                                <small>{{ $t('security_login_dialog.password_forgoten_3') }}</small>
                            </v-list>
                        </div>

                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="success" v-if="!passwordForgottenMode" @click="signIn()"><span class="white--text">{{ $t('security.btnSignIn') }}</span> </v-btn>
                    <v-btn color="default" v-if="passwordForgottenMode" @click="resetPassword()"> <span class="white--text">{{ $t('security_login_dialog.reset') }}</span> </v-btn>
                    <v-btn color="error" v-if="!passwordForgottenMode" @click="setForgottenPasswordMode(true)"><span class="white--text">{{ $t('security_login_dialog.password_forgoten_title') }}</span> </v-btn>
                    <v-btn color="warning" v-if="passwordForgottenMode" @click="setForgottenPasswordMode(false)"><span class="white--text">{{ $t('security_login_dialog.back') }}</span> </v-btn>

                    <div class="flex-grow-1"></div>
                    <v-btn rounded color="transparent" class="ma-2 flag-btn" v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language)">
                        <v-img :src="getImage(entry.flag)"></v-img>
                        <!--<flag :iso="entry.flag" v-bind:squared=false />-->
                        <!--{{entry.title}}-->
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>




</template>



<script>
    import { i18n } from '../Common/plugins/i18n';
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
    import ProgressBar from '../Common/Components/MyToolbarProgressBar.vue';
    import { setTimeout } from 'timers';

    export default {
        name: 'LoginDialog',

        props: {
            source: String,
        },

        computed: {
            ...mapState('loginModule', ['isLoginInProgress']),
            ...mapState('app', ['loginModal', 'languages']),
            ...mapGetters({ getTitleColorStore: 'app/getTitleColor' }),


            rules() {
                const rules1 = []
                if (this.min) {
                    const rule = v => (v || '').length >= this.min || this.$t('security.rules.password_length', { count: this.min })
                    rules1.push(rule)
                }
                if (!this.allowSpaces) {
                    const rule = v => (v || '').indexOf(' ') < 0 || this.$t('validation_noSpaces')
                    rules1.push(rule)
                }

                rules1.push(value => !!value || this.$t('validate.required_entry'))

                return rules1;
            },


        },


        methods: {
            ...mapActions({ setToken: 'app/setTokenWithExpiration', removeToken: 'app/removeToken' }),
            ...mapMutations('app', ['SET_LOGIN_MODAL', 'SET_PODRUZNICE']),
            ...mapMutations('loginModule', ['SET_LOGIN_PROGRESS']),

            changeLocale(locale) {
                localStorage.setItem('odabrani_jezik_aplikacije', locale);
                i18n.locale = locale;
            },

            signIn() {
                var self = this;
                this.loading = true;

                if (!this.passwordForgottenMode) {

                    var isFormOk = this.$refs.form.validate();
                    if (isFormOk) {
                        var data = { Username: this.username, Password: this.password };
                        this.$fetchDataPromise('/api/Auth/Login', data, null, true)
                            //.then(x => this.setToken(x))
                            .then(x => {
                                this.setToken(x);

                                const scriptContent = document.createElement('script');
                                scriptContent.innerHTML = `
                                        window.aichatbotApiKey = "ee27926b-a922-4f68-9265-783966b3be67";
                                        window.aichatbotProviderId = "f9e9c5e4-6d1a-4b8c-8d3f-3f9e9c5e46d1";
                                      `;
                                document.head.appendChild(scriptContent);

                                const scriptSrc = document.createElement('script');
                                scriptSrc.src = "https://script.chatlab.com/aichatbot.js";
                                scriptSrc.id = "ee27926b-a922-4f68-9265-783966b3be67";
                                scriptSrc.defer = true;
                                document.head.appendChild(scriptSrc);

                                if (x.PrvaPrijava) {
                                    self.$router.push('/Portal/Security/PasswordChange');
                                } else {
                                    self.$router.push('/');
                                }

                                self.SET_LOGIN_MODAL(false);
                                self.password = '';
                                self.loading = false;
                                self.ucitajPodruznice();

                            })
                            .catch(x => {
                                self.$displayError(self.$t(x));
                                self.loading = false;
                            })
                    } else {
                        this.$displayInfo(this.$t('security.login_error'));
                        this.loading = false;
                    }
                }

            },

            ucitajPodruznice() {
                var self = this;
                //self.loadPodruznice(false); // Ovdje i u App.vue ucitavam, ovisno ima li nešto ili ne....
                if (this.$hasTokenExpired() == false) {

                    this.$fetchDataPromise('/api/Base/GetPodruznice', null, null, false)
                        .then(x => { this.SET_PODRUZNICE({ data: x, force: false }) })
                        .catch(x => self.$displayError(self.$t(x)));
                }
            },

            setForgottenPasswordMode(mode) {
                this.passwordForgottenMode = mode;
            },

            resetPassword() {
                this.loading = true;
                var self = this;
                if (this.username && this.username.trim().length > 0) {
                    var data = { uid: this.username };
                    this.$fetchDataPromise('/api/Auth/ResetPassword', data, 'POST', true)
                        .then(x => {
                            this.$displaySuccess(x);
                            this.setForgottenPasswordMode(false);
                            this.loading = false;
                        })
                        .catch(x => {
                            self.loading = false;
                            self.$displayError(self.$t(x))
                        })

                } else {
                    this.$displayError(this.$t('security_login_dialog.username_missing'))
                    this.loading = false;
                }
            },

            getImage(img) {
                switch (img) {
                    case 'hr': return '/assets/images/icons/flag_croatia.png';
                    case 'us': return '/assets/images/icons/flag_united-kingdom.png';
                    default: return ''
                }
            }

        },
        mounted() {
            var tokenExpired = this.$hasTokenExpired();
            this.SET_LOGIN_MODAL(tokenExpired);
        },

        data() {
            return {
                autofocus: true,
                autocomplete: 'on',
                algebraLogo: '/assets/images/logos/header-img1.png',
                background_logo: '/assets/images/logos/algebra-pozadina-polu-logo.png',
                logoHeight: 30,
                logoWidth: this.logoHeight * 1.42,
                loading: false,
                //min: 3,
                required: true,
                allowSpaces: false,
                username: '',
                password: '',
                isFormOK: false,
                show1: false,

                //dialog: true,
                notifications: false,
                sound: true,
                widgets: false,
                passwordForgottenMode: false,
                mailto: `mailto:${this.$t("security_login_dialog.password_forgoten_2")}`
            }
        },
        components: {
            ProgressBar
        }
    }
</script>

<style scoped>
    .text-dark {
        color: black !important;
    }

    .md .mlnegative {
        margin-left: 0 !important;
    }
</style>

<style>
    /* Fix texta u toolbaru */
    .kill-margin * {
        margin-left: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// VueSrc/Security/LoginDialog.vue